import rest from "../script/rest";

class GeoRest {

    async getBuildings(long, lat, offsetMeters) {
        const url = "/rest/lod2/buildings"
        + "?long=" + encodeURIComponent(long)
        + "&lat=" + encodeURIComponent(lat)
        + "&offsetMeters=" + encodeURIComponent(offsetMeters);
        const response = await rest.get(url);
        return response.json();
    }
}
const geoRest = new GeoRest();
window.geoRest = geoRest;
export default geoRest;